import { render } from "./navMenuTree.vue?vue&type=template&id=4c5488c8&scoped=true"
import script from "./navMenuTree.vue?vue&type=script&lang=js"
export * from "./navMenuTree.vue?vue&type=script&lang=js"

import "./navMenuTree.vue?vue&type=style&index=0&id=4c5488c8&lang=scss&scoped=true"

import exportComponent from "G:\\frontend\\dse-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5488c8"]])

export default __exports__